const media = {
  small: 768,
  medium: 992,
  large: 1024
}

export default media
